<template>
    <div>
        <div class=" mb-5">
            <!-- shape Hero -->
            <section class="section-shaped my-0 pb-lg-5">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex pb-3">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3 ">My Orders
                                </h1>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container shape-container d-flex  border rounded">
                    <div class="col px-0">
                        <div class="row no-gutters bg-white">
                            <div class="col-md-3 " style="border-right: 1px solid #e0e0e0">
                                <div class="card-body">
                                    <div class="filter-bar ui basic segment grid">
                                        <div class="ui form">
                                            <div class="inline field">
                                                <h6 class="heading-small text-muted mb-4">Account DashBoard</h6>

                                                <hr class="my-4 mb-0" />
                                                <div class="list-group list-group-flush">
                                                    <router-link  :to="{ name: 'account', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0"> Account Information</router-link>
                                                    <router-link  :to="{ name: 'address', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0"> Addresses</router-link>
                                                    <router-link :to="{ name: 'orders', params: { storeName: $route.params.storeName, accountName: $route.params.accountName}}" class="list-group-item list-group-item-action border-0 active">My Orders</router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="card-header border-0">
                                    <a-button v-if="viewOrder==true" type="primary" @click.prevent="backToOrderList"> <a-icon type="left"  class="align-middle"/>Go back </a-button>
                                </div>
                                <div class="card-body pt-2">
                                    <div v-show="viewOrder==false" class="table-responsive pt-2">
                                        <div id="order-table">sada</div>
                                    </div>
                                    <div v-show="viewOrder==true" v-if="viewOrder==true" >
                                        <a-tabs default-active-key="1" @change="callback">
                                            <a-tab-pane key="1" tab="Items Ordered" force-render>
                                                <div class="table-responsive">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th>Product Name</th>
                                                                <th>Price</th>
                                                                <th>Qty</th>
                                                                <th class="align-middle  text-right" align="right">Subtotal</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(data,index) in orderDetails.document_lines" v-bind:key="index">
                                                                <td>{{data.product_name}}</td>
                                                                <td>{{data.price}}</td>
                                                                <td>{{data.quantity}}</td>
                                                                <td class="align-middle" align="right">{{formatPrice(data.subtotal)}}</td>
                                                            </tr>
                                                            <tr class="border-top" v-if="orderDetails.total_amount-totalAmount!=0">
                                                                <td colspan="3" align="left"><h5>Shipping fee</h5></td>
                                                                <td align="right" class="font-weight-bold">{{formatPrice(orderDetails.total_amount-totalAmount)}}</td>
                                                            </tr>
                                                            <tr class="border-top">
                                                                <td colspan="3" align="left"><h5>Total</h5></td>
                                                                <td align="right" class="font-weight-bold">{{formatPrice(totalAmount+(orderDetails.total_amount-totalAmount))}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-tab-pane>
                                            <a-tab-pane key="2" tab="Invoices">
                                                <div style="height: 20vh;"></div>
                                            </a-tab-pane>
                                        </a-tabs>
                                        <div class="row">
                                            <div class="col">
                                                <h3 class="heading-small text-muted mb-4">Shipping Address</h3>
                                                <p>{{orderDetails.shipping_address}}</p>
                                            </div>
                                            <div class="col">
                                                <h3 class="heading-small text-muted mb-4">Shipping Method</h3>
                                                <p>{{orderDetails.shipping_method}}</p>
                                                <small v-if="orderDetails.shipping_method=='store pickup'">
                                                    <span class="font-weight-bold">pickup Address:</span> {{siteDetails.name}} branch <br><span v-if="siteDetails.address!=null">{{' - '+siteDetails.address}}</span>
                                                </small>
                                            </div>
                                            <div class="col">
                                                <h3 class="heading-small text-muted mb-4">Contact Person</h3>
                                                <p>
                                                    {{orderDetails.email}}
                                                    {{orderDetails.contact_number}}
                                                </p>
                                            </div>
                                            <div class="col">
                                                <h3 class="heading-small text-muted mb-4">Order Status</h3>
                                                <p>{{orderStatus(orderDetails.order_status,orderDetails.status)}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
    </div>
</template>
<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import Tabulator from 'tabulator-tables';
var table;
export default {
    components: {
        HTTPRequest
    },
    computed: {
        ...mapState(['endPoint', 'parameters'])
    },
    data() {
        return {
            email:null,
            password:null,
            options: {
                layout:"fitDataStretch",
                ajaxURL:'',
                ajaxConfig:{
                    method:"GET", 
                    headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")},
                },
                pagination:"remote",
                paginationDataSent:{
                    "page":"page",
                    "size":"per_page"
                },
                showData:[],
                paginationSize:10,
                columns:[
                    {title: 'Order #', field: "order_id", align:'center', headerSort:false},
                    {title: 'Date', formatter: this.FormatDate, width:200, headerSort:false},
                    {title: 'Amount', field: 'total_amount', headerSort:false},
                    {title: 'Order Status', field: 'order_status',formatter: this.OrderStatusFormatter, headerSort:false},
                    {title: 'Action',align:'center',formatter: this.addButton,cellClick: this.OrderAction,headerSort: false},
                ],
            },
            CustomerDetailsLogin: {},
            viewOrder:false,
            orderDetails:{},
            totalAmount:0,
            siteDetails:{}
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        if(autoLogin == true){
            this.$emit('showFooterAndHeader', event)
            this.$emit('hideSearchInput', event)
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            if (secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus") != true){
                this.$router.push({ name: 'store', params:{storeId:this.$route.params.storeId}})
            }else{
                this.CustomerDetailsLogin = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin")
                this.allData()
            }
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'orders', storeId:this.$route.params.storeId }})
        }
    },
    methods:{
        addButton (cell, formatterParams){
            let id = cell.getRow().getData().id
            var button = ""
            button += '<button id="' + id + '" name="View" class="btn btn-success btn-sm">View Order</button>'
            return button
        },
        allData: async function(){
            this.options.ajaxURL = this.endPoint + 'orders?email='+this.CustomerDetailsLogin.email+'&name=' + this.storeDetails.name + '&account_id='+this.storeDetails.account_id
            table = new Tabulator("#order-table", this.options);
        },
        OrderStatusFormatter(cell, formatterParams){
            let orderStatus = cell.getRow().getData().order_status
            let status = cell.getRow().getData().status
            console.log(cell.getRow().getData())
            var text = this.orderStatus(orderStatus,status)
            return text
        },
        FormatDate(cell, formatterParams){
            let orderDate = cell.getRow().getData().document_date
            var text = ""
            text = moment(orderDate).format('YYYY-MM-DD')
            return text
        },
        OrderAction: function(e, cell){
            this.viewOrder = true
            this.showOrder(e.target.id)
        },
        showOrder: async function(id){
            var response = await HTTPRequest.getRequest(this.endPoint + 'orders/' + id+'?name=' + this.storeDetails.name + '&account_id='+this.storeDetails.account_id, null)
            if (response["error"]==undefined){
                this.orderDetails = response
                if(this.orderDetails.shipping_method == "store pickup"){
                    this.getSiteDetails(response.site_pickup_id)
                }
                this.totalAmount = this.totalItem()
                console.log(response)
            }
        },
        backToOrderList(){
            this.viewOrder = false
            this.orderDetails = {}
            this.allData()
        },
        callback(key) {
        },
        totalItem: function(){
            let sum = 0;
            for(let i = 0; i < this.orderDetails.document_lines.length; i++){
                sum += (parseFloat(this.orderDetails.document_lines[i].price) * parseFloat(this.orderDetails.document_lines[i].quantity));
            }
            return sum;
        },
        formatPrice: function(value) {
            let val = (value/1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        orderStatus(orderStatus,status){
            switch (true) {
            case (orderStatus == 'U' && status != 'V'):
                return "Unfulfilled"
            break;
            case (orderStatus == 'F' && status != 'V'):
                return "Fulfilled"
            break;
            case (orderStatus == 'G' && status != 'V'):
                return "Goods Issued"
            break;
            case (orderStatus == 'O' && status != 'V'):
                return "Open Delivery"
            break;
            case (orderStatus == 'P' && status != 'V'):
                return "Partially Fulfilled"
            break;
            case (status == 'V'):
                return "Voided"
            break;
            default:
            break;
            }
        },
        getSiteDetails:async function(site_id){
            var response = await HTTPRequest.getRequest(this.endPoint + 'orders/get_pickup_site_details?site_id='+site_id, null)
            if (response["error"]==undefined){
                console.log(response)
                this.siteDetails = response
            }
        }
    }
};
</script>

<style lang='scss'>
  @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
</style>